import type { FileReader } from '@/platform'
import EventBase from './EventBase'
import EventMaker from './EventMaker'
import EventID from './EventID'

import EventAd from './EventAd'
import EventAdChoice from './EventAdChoice'
import EventAddItem from './EventAddItem'
import EventAutoPlay from './EventAutoPlay'
import EventBackTitle from './EventBackTitle'
import EventBGMAdd from './EventBGMAdd'
import EventBookMark from './EventBookMark'
import EventBubble from './EventBubble'
import EventBubbleMode from './EventBubbleMode'
import EventButtonDif from './EventButtonDif'
import EventButtonDifChoose from './EventButtonDifChoose'
import EventButtonDifEnd from './EventButtonDifEnd'
import EventCallMenu from './EventCallMenu'
import EventCallSubStory from './EventCallSubStory'
import EventCGAdd from './EventCGAdd'
import EventComment from './EventComment'
import EventConvertSceneStart from './EventConvertSceneStart'
import EventDisableMenu from './EventDisableMenu'
import EventDisposePic from './EventDisposePic'
import EventDisposeText from './EventDisposeText'
import EventFadeBGM from './EventFadeBGM'
import EventFadeBGS from './EventFadeBGS'
import EventFlash from './EventFlash'
import EventFloatControl from './EventFloatControl'
import EventForcedSaveRead from './EventForcedSaveRead'
import EventFreshUI from './EventFreshUI'
import EventGifPicShow from './EventGifPicShow'
import EventIF from './EventIF'
import EventIfChoice from './EventIfChoice'
import EventIFEnd from './EventIFEnd'
import EventJumpStory from './EventJumpStory'
import EventJumpStoryUI from './EventJumpStoryUI'
import EventLoop from './EventLoop'
import EventLoopAboveStart from './EventLoopAboveStart'
import EventLoopBreaK from './EventLoopBreaK'
import EventMaskPic from './EventMaskPic'
import EventMediaPlayNode from './EventMediaPlayNode'
import EventMediaPlayOver from './EventMediaPlayOver'
import EventMediaPlayShow from './EventMediaPlayShow'
import EventMoodShow from './EventMoodShow'
import EventMovePic from './EventMovePic'
import EventNotSelect from './EventNotSelect'
import EventOaf from './EventOaf'
import EventOpenUrl from './EventOpenUrl'
import EventPicShow from './EventPicShow'
import EventPlanConvertScene from './EventPlanConvertScene'
import EventPromptMessage from './EventPromptMessage'
import EventQuickPlay from './EventQuickPlay'
import EventResourceLoad from './EventResourceLoad'
import EventReturnGameUI from './EventReturnGameUI'
import EventRotatePic from './EventRotatePic'
import EventSendAirBubble from './EventSendAirBubble'
import EventSeniorIf from './EventSeniorIf'
import EventSeniorVar from './EventSeniorVar'
import EventShake from './EventShake'
import EventSimpleEffect from './EventSimpleEffect'
import EventStartBGM from './EventStartBGM'
import EventStartBGS from './EventStartBGS'
import EventStartSE from './EventStartSE'
import EventStartVoice from './EventStartVoice'
import EventStopSE from './EventStopSE'
import EventStopVoice from './EventStopVoice'
import EventStoryLock from './EventStoryLock'
import EventString from './EventString'
import EventText from './EventText'
import EventTextChoice from './EventTextChoice'
import EventTextDif from './EventTextDif'
import EventTextDifEx from './EventTextDifEx'
import EventTextDifEx2 from './EventTextDifEx2'
import EventTextEnd from './EventTextEnd'
import EventUnlockCollect from './EventUnlockCollect'
import EventUpateSceneHue from './EventUpateSceneHue'
import EventValueInput from './EventValueInput'
import EventVar from './EventVar'
import EventVarsEx from './EventVarsEx'
import EventVitLock from './EventVitLock'
import EventWait from './EventWait'
import EventWeather from './EventWeather'
import EventCallScene from './EventCallScene'
import EventObj from './EventObj'
import EventArray from './EventArray'
import EventArrayElement from './EventArrayElement'
import EventVideoShow from './EventVideoShow'
import EventDressRole from './EventDressRole'

type EventCtor = new (...args: any[]) => EventBase

/** 可实例化的事件类（排除抽象基类、工具类） */
const EVENT_CTORS: EventCtor[] = [
  EventAd,
  EventAdChoice,
  EventAddItem,
  EventAutoPlay,
  EventBackTitle,
  EventBGMAdd,
  EventBookMark,
  EventBubble,
  EventBubbleMode,
  EventButtonDif,
  EventButtonDifChoose,
  EventButtonDifEnd,
  EventCallMenu,
  EventCallSubStory,
  EventCGAdd,
  EventComment,
  EventConvertSceneStart,
  EventDisableMenu,
  EventDisposePic,
  EventDisposeText,
  EventFadeBGM,
  EventFadeBGS,
  EventFlash,
  EventFloatControl,
  EventForcedSaveRead,
  EventFreshUI,
  EventGifPicShow,
  EventIF,
  EventIfChoice,
  EventIFEnd,
  EventJumpStory,
  EventJumpStoryUI,
  EventLoop,
  EventLoopAboveStart,
  EventLoopBreaK,
  EventMaskPic,
  EventMediaPlayNode,
  EventMediaPlayOver,
  EventMediaPlayShow,
  EventMoodShow,
  EventMovePic,
  EventNotSelect,
  EventOaf,
  EventOpenUrl,
  EventPicShow,
  EventPlanConvertScene,
  EventPromptMessage,
  EventQuickPlay,
  EventResourceLoad,
  EventReturnGameUI,
  EventRotatePic,
  EventSendAirBubble,
  EventSeniorIf,
  EventSeniorVar,
  EventShake,
  EventSimpleEffect,
  EventStartBGM,
  EventStartBGS,
  EventStartSE,
  EventStartVoice,
  EventStopSE,
  EventStopVoice,
  EventStoryLock,
  EventString,
  EventText,
  EventTextChoice,
  EventTextDif,
  EventTextDifEx,
  EventTextDifEx2,
  EventTextEnd,
  EventUnlockCollect,
  EventUpateSceneHue,
  EventValueInput,
  EventVar,
  EventVarsEx,
  EventVitLock,
  EventWait,
  EventWeather,
  EventCallScene,
  EventObj,
  EventArray,
  EventArrayElement,
  EventVideoShow,
  EventDressRole,
]

function buildCodeMap(): Map<number, EventCtor> {
  const m = new Map<number, EventCtor>()
  for (const Ctor of EVENT_CTORS) {
    try {
      const inst = new Ctor()
      const code = inst.Code
      if (typeof code === 'number' && !Number.isNaN(code)) {
        m.set(code, Ctor)
      }
    } catch {
      /* abstract or bad ctor */
    }
  }
  return m
}

const CODE_TO_CTOR = buildCodeMap()

type EventLike = Partial<EventBase> & Record<string, unknown>

/**
 * 新建一条空事件（用于编辑器插入）：按 Code 选用已注册子类默认构造，并走 EventMaker 后处理。
 */
export function createEmptyEventByCode(code: number): EventBase {
  const Ctor = CODE_TO_CTOR.get(code) ?? EventBase
  const inst = new Ctor()
  if (Ctor === EventBase) {
    inst.Code = code as EventID
  }
  try {
    return EventMaker.maker(inst)
  } catch {
    return inst
  }
}

/**
 * 从工程二进制流读取一条事件：先 peek Code，再按类型 new 正确子类并 readBin，最后走 EventMaker 后处理。
 */
export function createEventFromReader(reader: FileReader): EventBase {
  const pos = reader.getPosition()
  const code = reader.readInt()
  reader.seek(pos)

  const Ctor = CODE_TO_CTOR.get(code) ?? EventBase
  const inst = new Ctor()
  inst.readBin(reader)
  try {
    return EventMaker.maker(inst)
  } catch {
    return inst
  }
}

/**
 * 把任意“事件形态对象”收敛成真正的事件实例。
 *
 * 典型场景：
 * - `MapInfo.readBin()` 早期按 `EventBase` 读取，丢失具体子类原型
 * - 某些链路把事件做成了普通对象，导致 `RoleName` / `Content` 之类变成独立字段
 *
 * 约束：
 * - 最终必须返回与 `Code` 对应的真实事件子类实例
 * - `Parameter` 仍然是单一事实来源；若源对象上还有同名业务字段，则通过 setter 再回写一遍
 */
export function ensureEventInstance(event: EventBase | EventLike): EventBase {
  if (!event || typeof event !== 'object') {
    return new EventBase()
  }

  const code = Number((event as EventLike).Code ?? -1)
  const Ctor = CODE_TO_CTOR.get(code) ?? EventBase
  if (event instanceof Ctor) {
    try {
      return EventMaker.maker(event)
    } catch {
      return event
    }
  }

  const inst = new Ctor()
  const source = event as EventLike

  if (Array.isArray(source.Parameter)) {
    inst.Parameter = source.Parameter.map((item) => (item == null ? '' : String(item)))
  }
  if (typeof source.Code === 'number' && Ctor === EventBase) {
    inst.Code = source.Code as EventID
  }

  for (const key of Object.keys(source)) {
    if (key === 'Parameter' || key === 'eventClassName') continue
    try {
      ;(inst as unknown as Record<string, unknown>)[key] = source[key]
    } catch {
      /* ignore readonly / incompatible field */
    }
  }

  inst.eventClassName = Ctor.name
  try {
    return EventMaker.maker(inst)
  } catch {
    return inst
  }
}

/** 把事件数组中的每一项都收敛成真实实例，并尽量复用原数组引用。 */
export function ensureEventListInstances(list: Array<EventBase | EventLike> | null | undefined): EventBase[] {
  if (!Array.isArray(list)) return []
  for (let i = 0; i < list.length; i += 1) {
    list[i] = ensureEventInstance(list[i] as EventBase | EventLike)
  }
  return list as EventBase[]
}

/** 可作为「折叠块头」的事件：条件分歧、循环、剧情分歧系列、按钮分歧 */
export function isFoldBlockHeader(code: number): boolean {
  return (
    code === EventID.IF ||
    code === EventID.SeniorIf ||
    code === EventID.Loop ||
    code === EventID.TextDif ||
    code === EventID.TextDifEx ||
    code === EventID.TextDifEx2 ||
    code === EventID.ButtonDif
  )
}
